import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Common.scss';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="page-layout">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <Card className="shadow-sm">
              <Card.Header>
                <h1 className="mb-0">プライバシーポリシー</h1>
              </Card.Header>
              <Card.Body>
                <div className="content-section">
                  <p className="mb-4">
                    ヒーリングサロン
                    Gundari（以下「当サロン」）は、お客様の個人情報の保護に関し、以下のとおりプライバシーポリシーを定め、個人情報保護の仕組みを構築し、個人情報保護の重要性の認識と取組みを徹底することにより、個人情報の保護を推進致します。
                  </p>

                  <h5>1. 個人情報の管理</h5>
                  <p>
                    当サロンは、お客様の個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・従業員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行います。
                  </p>

                  <h5>2. 個人情報の利用目的</h5>
                  <p>
                    お客様からお預かりした個人情報は、当サロンからのご連絡や業務のご案内やご質問に対する回答として、以下の目的で利用いたします。
                  </p>
                  <ul>
                    <li>ヒーリングセッションの予約管理および提供</li>
                    <li>お客様への連絡（予約確認、変更、キャンセル等）</li>
                    <li>サービス向上のためのアンケートの実施</li>
                    <li>
                      新サービスやキャンペーンのご案内（お客様の同意がある場合のみ）
                    </li>
                    <li>お問い合わせに対する対応</li>
                  </ul>

                  <h5>3. 個人情報の第三者への開示・提供の禁止</h5>
                  <p>
                    当サロンは、お客様よりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。
                  </p>
                  <ul>
                    <li>お客様の同意がある場合</li>
                    <li>法令に基づき開示することが必要である場合</li>
                    <li>
                      人の生命、身体または財産の保護のために必要がある場合
                    </li>
                  </ul>

                  <h5>4. 個人情報の安全対策</h5>
                  <p>
                    当サロンは、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。
                  </p>

                  <h5>5. 個人情報の照会・修正・削除</h5>
                  <p>
                    お客様がご本人の個人情報の照会・修正・削除を希望される場合には、ご本人であることを確認の上、対応させていただきます。
                  </p>

                  <h5>6. Cookie（クッキー）について</h5>
                  <p>
                    当サロンのウェブサイトでは、サービス向上のためにCookieを使用する場合があります。Cookieの使用を望まない場合は、ブラウザの設定でCookieを無効にしてください。
                  </p>

                  <h5>7. SSL（暗号化通信）について</h5>
                  <p>
                    個人情報の送信時には、SSL（Secure Socket
                    Layer）による暗号化通信を使用し、情報の保護に努めています。
                  </p>

                  <h5>8. プライバシーポリシーの変更</h5>
                  <p>
                    当サロンは、このプライバシーポリシーの内容を適宜見直し、その改善に努めます。修正された最新のプライバシーポリシーは常に本ページにて開示されます。
                  </p>

                  <h5>9. お問い合わせ先</h5>
                  <p>
                    本ポリシーに関するお問い合わせは、当サロンまでご連絡ください。
                  </p>
                  <p className="mt-4">
                    <strong>制定日：</strong> 2025年11月3日
                    <br />
                    <strong>ヒーリングサロン Gundari</strong>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
